export default __webpack_public_path__ + "static/media/regulatory--no-carts--g2.b6f19e6f.png";